module.exports = __webpack_public_path__ + "static/okash1n-b71ee61561c69eabfa87d631acbb1d02.jpg";